import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { deviceStatus } from '@helpers/Constants';
import { modeList, Mode } from './contants';
import { ModeItem } from './index.d';

import NavBar from '@components/NavBar';
import Toast from '@widgets/Toast';
import ConfirmModal  from '@components/ConfirmModal';
interface ItemProps {
  item: ModeItem;
  onSelect: (value: number) => void;
  selected: boolean;
}

const Item = (props: ItemProps) => {
  const { item, selected, onSelect } = props;
  const clickItem = () => {
    onSelect && onSelect(item.value);
  }
  return (
    <div className="flex" styleName="item" onClick={ clickItem }>
      <div className="flex" styleName="item-title-left">
        <span styleName="item-title">{ item.title }</span>
        <span styleName="item-desc">{ item.desc }</span>
      </div>
      { selected ?  <i className="iconfont icon-chenggong" /> : null}
    </div>
  )
}

const MovePathMode = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [selectMode, setMode] = useState(-1);
  const editMode = async (value: number) => {
    try {
      const { data } = await Http.post(Api.GetCardInfoBySncode,
        { snCode: params.current.sncode, company: params.current.company }
      );
      if(data?.status === deviceStatus.locked) {
        return ConfirmModal.show({
          title: '设备已锁定',
          text: '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
          confirmBtnText: '我知道了'
        })
      } else if (data?.status === deviceStatus.forbid) {
        return ConfirmModal.show({
          title: '设备已禁用',
          text: '设备已被服务商禁用，请联系服务商解除。',
          confirmBtnText: '我知道了',
          confirmBtnStyle: { backgroundColor: '#F2F4F7', color: '#55585C'},
        })
      }
      if(!data?.isOnLine) {
        return Toast.show({
          type: 'strip',
          title: '设备离线，请联网后设置'
        });
      }
      await Http.post(Api.PostDeviceLocationPattern,
        { snCode: params.current.sncode, company: params.current.company, pattern: value }
      );
      setMode(value);
    } catch (error) {
      
    }
  }

  const getModeInfo = async() => {
    const { data } = await Http.post(Api.GetDeviceLocationPattern,
      { snCode: params.current.sncode, company: params.current.company }
    );
    if(data) {
      setMode(data.pattern || Mode.saving);
    }
  }

  const renderMode = () => {
    const items = modeList.map((item: any, index: number) => {
      return (
        <Item key={ index } item={ item } onSelect={ editMode } selected={ item.value === selectMode} />
      )
    })

    return items;
  }

  useEffect(() => {
    getModeInfo();
  }, [])

  return (
    <div styleName="container" style={{ height: document.body.clientHeight  }}>
      <NavBar
        title="轨迹模式"
        transparent
      />
      <div styleName="list">
        { renderMode() }
      </div>
    </div>
  )
}

export default MovePathMode;
